<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-gap-10">
    <h1 class="tw-text-3xl">
      API Error Testing
    </h1>

    <div
      v-if="isAllowed"
      class="tw-flex tw-gap-10"
    >
      <section>
        <h2>Django Rest Framework</h2>
        <div>
          <button @click="triggerError('ValidationError')">
            ValidationError
          </button>

          <button @click="triggerError('PermissionDenied')">
            PermissionDenied
          </button>
        </div>
      </section>

      <section>
        <h2>Python</h2>
        <div>
          <button @click="triggerError('ValueError')">
            ValueError
          </button>

          <button @click="triggerError('TypeError')">
            TypeError
          </button>
        </div>
      </section>

      <section>
        <h2>HTTP</h2>
        <div>
          <button @click="triggerError('400')">
            400
          </button>

          <button @click="triggerError('403')">
            403
          </button>
        </div>
      </section>

      <section>
        <h2>Other</h2>
        <div>
          <button @click="triggerError('Task')">
            Task
          </button>
        </div>
      </section>
    </div>

    <div
      v-else
      class="tw-flex tw-flex-col tw-items-center tw-gap-3"
    >
      <i class="fas fa-ban tw-text-3xl tw-text-rose-600" />
      <h2 class="tw-text-lg tw-text-gray-600">
        Only the YourStake team can access this page
      </h2>
    </div>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';


export default {
  name: 'ErrorTestView',
  components: {
    // Subcomponents
  },
  props: {
    // Inputs
  },
  data() {
    return {
      // Local variables
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
    isAllowed() {
      return this.advisorStore?.featureFlags?.includes('Internal');
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    async triggerError(name) {
      const res = await fetch('/api/v1/errors/' + name, {
        method: 'GET',
        headers: this.headers,
      });

      const data = await res.json();
      console.log('Response Data', data);
    },
  },
};
</script>


<style scoped>
section {
  @apply tw-flex tw-flex-col tw-items-center tw-gap-5;
}

section > h2 {
  @apply tw-text-lg tw-font-bold;
}

section > div {
  @apply tw-flex tw-flex-col tw-gap-5;
}

button {
  @apply tw-px-4 tw-py-2 tw-rounded-md tw-border-none;
  @apply tw-font-mono tw-text-lg;
  @apply tw-bg-rose-300 hover:tw-bg-rose-500 hover:tw-cursor-pointer;
}
</style>
